import { Button } from '@mui/material';
import { BusinessReject } from 'components/Table/renderers/SolaceQueueMessageRenderer/fixMessageTypes';
import styles from 'components/Table/renderers/SolaceQueueMessageRenderer/solace-queue-message-renderer.module.scss';
import React from 'react';

interface Props {
  readonly message: BusinessReject;

  onActionClick(): void;
}

export const FIXBusinessRejectionDetailsRenderer: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  const { onActionClick } = props;
  const { message } = props;

  return (
    <div className={styles.fixMessageDetails}>
      <div>{message.BusinessRejectReason}</div>
      <div className={styles.senderTarget}>
        <div>{message.SenderCompID ?? '?'}</div>
        <div>&rarr;</div>
        <div>{message.TargetCompID ?? '?'}</div>
      </div>
      <div className={styles.viewDetailsButton}>
        <Button classes={viewDetailsButton} onClick={onActionClick}>
          Show FIX message
        </Button>
      </div>
    </div>
  );
};

const viewDetailsButton = { root: styles.viewDetailsButtonRoot };
